import Link from "@mui/material/Link";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
  useLocation,
} from "react-router-dom";
import React from "react";
import { Stack } from "~/components/ui/stack";
import {
  CalendarFilledIcon,
  GridFilledIcon,
  IconProps,
  AlertTriangleFilledIcon,
  MessageTypingFilledIcon,
} from "~/components/ui/icon";
import { Text } from "~/components/ui/text";

export type NavLinkProps = RouterLinkProps & {
  icon?: React.ComponentType<IconProps>;
  noLink?: boolean;
  active: boolean;
};

export const NavLink = ({
  icon: Icon,
  children,
  active,
  ...props
}: NavLinkProps) => {
  const tone = active ? "action" : "muted";

  const label = (
    <Stack direction="row" gap="small" align="center">
      {Icon && <Icon tone={tone} size="xxsmall" />}

      <Text tone={tone} weight="medium">
        {children}
      </Text>
    </Stack>
  );

  return props.noLink ? (
    label
  ) : (
    <Link {...props} component={RouterLink} underline="none">
      {label}
    </Link>
  );
};

export const useNavLinks = () => {
  const { pathname } = useLocation();
  return [
    <NavLink
      key="units"
      icon={GridFilledIcon}
      to="/units"
      active={pathname.startsWith("/units")}
    >
      Unit
    </NavLink>,
    <NavLink
      key="availability"
      icon={CalendarFilledIcon}
      to="/availability"
      active={pathname.startsWith("/availability")}
    >
      Availability
    </NavLink>,
    <NavLink
      key="requests"
      icon={AlertTriangleFilledIcon}
      to="/requests?tab=operational"
      active={pathname.startsWith("/requests")}
    >
      Requests
    </NavLink>,
    <NavLink
      key="messages"
      icon={MessageTypingFilledIcon}
      to="/messages"
      active={pathname.startsWith("/messages")}
    >
      Messages
    </NavLink>,
  ];
};
